import React from 'react';
import PropTypes from "prop-types";
import classnames from 'classnames';
import styles from './styles.module.scss';

const StatusBadge = ({id, name}) => {
  switch (id) {
    case 3:
      return <div className={classnames(styles.container, styles.rejected)}>{name}</div>
    case 4:
      return <div className={classnames(styles.container, styles.approved)}>{name}</div>
    case 5:
      return <div className={classnames(styles.container, styles.completed)}>{name}</div>
    case 6:
      return <div className={classnames(styles.container, styles.pendingReview)}>{'ממתין לבדיקה'}</div>
    case 7:
      return <div className={classnames(styles.container, styles.pendingSignature)}>{'ממתין לאישור סופי'}</div>
    case 8:
      return <div className={classnames(styles.container, styles.completedManually)}>{'הסתיים (ידני)'}</div>
    case 9:
      return <div className={classnames(styles.container, styles.frozen)}>{'מוקפא'}</div>
    case 10:
      return <div className={classnames(styles.container, styles.cancelled)}>{'מבוטל'}</div>
    case 1:
    default:
      return <div className={classnames(styles.container, styles.inProgress)}>{name}</div>
  }
}

StatusBadge.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
};

export default StatusBadge;
